import { getListRfqGroupKey } from './groupListRfqOrders';

const rowKey = (order) => getListRfqGroupKey(order) || `order:${order.orderId ?? order.id}`;

export const countOrdersBlotterRows = (orders) => new Set(orders.map(rowKey)).size;

// State remains flat for existing order/quote actions, but page limits and totals
// count each list once. Trimming a page must never trim a list's children.
export const updateOrdersBlotter = (orders, update, maxRows, remove = false) => {
  const targetId = update.orderId ?? update.id;
  const index = orders.findIndex((order) => String(order.orderId ?? order.id) === String(targetId));
  if (remove && index === -1) return { orders, totalDelta: 0 };

  const updated = remove
    ? orders.filter((_, i) => i !== index)
    : index === -1
      ? [update, ...orders]
      : orders.map((order, i) => i === index ? { ...order, ...update } : order);
  const totalDelta = countOrdersBlotterRows(updated) - countOrdersBlotterRows(orders);
  const keys = new Set();
  const limited = updated.filter((order) => {
    const key = rowKey(order);
    if (!keys.has(key) && keys.size >= maxRows) return false;
    keys.add(key);
    return true;
  });
  return { orders: limited, totalDelta };
};
